import script from "./ArticleSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleSection.vue?vue&type=script&setup=true&lang=js"

import "./ArticleSection.vue?vue&type=style&index=0&id=65fdf582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65fdf582"]])

export default __exports__